import axios, { AxiosInstance } from "axios";
import { ImageUploader } from "@/models/uploaders/image.uploader";
import { FileUploader, FilesUploader } from "@/models/uploaders/file.uploader";
import { ResultUploader } from "@/models/uploaders/result.uploader";

export class UploaderService {
  cdnUrl: string = process.env.VUE_APP_CDN_URL;
  axios: AxiosInstance = axios.create();

  UploadSingleFile(imageUploader: FileUploader): Promise<ResultUploader> {
    const formData = new FormData();
    formData.append("Folder", imageUploader.folder || "");
    formData.append("File", imageUploader.file);
    // TODO Cannot send autohrization to cdn
    return new Promise<ResultUploader>((resolve, reject) => {
      this.axios
        .post<ResultUploader[]>(`${this.cdnUrl}api/upload/single`, formData, {
          headers: null
        })
        .then(response => resolve(response.data[0] as ResultUploader))
        .catch(error => reject(error));
    });
  }

  UploadSinglePhoto(imageUploader: ImageUploader): Promise<ResultUploader> {
    const formData = new FormData();
    formData.append("Folder", imageUploader.folder || "");
    formData.append("File", imageUploader.image);
    // TODO Cannot send autohrization to cdn
    return new Promise<ResultUploader>((resolve, reject) => {
      this.axios
        .post<ResultUploader[]>(
          `${this.cdnUrl}api/upload/image/single`,
          formData,
          {
            headers: null
          }
        )
        .then(response => resolve(response.data[0] as ResultUploader))
        .catch(error => reject(error));
    });
  }

  // UploadSingleDocument(filesUploader: FilesUploader): Promise<ResultUploader> {
  //   const formData = new FormData();
  //   formData.append("Folder", filesUploader.folder || "");
  //   formData.append("Files", JSON.stringify(filesUploader.files));
  //   return new Promise<ResultUploader>((resolve, reject) => {
  //     this.axios
  //       .post<ResultUploader[]>(
  //         `${this.cdnUrl}api/upload/document/single`,
  //         formData,
  //         {
  //           headers: null
  //         }
  //       )
  //       .then(response => resolve(response.data[0] as ResultUploader))
  //       .catch(error => reject(error));
  //   });
  // }

  UploadMultipleDocument(
    filesUploader: FilesUploader
  ): Promise<ResultUploader[]> {
    const formData = new FormData();
    formData.append("Folder", filesUploader.folder || "");
    filesUploader.files.forEach(element => {
      formData.append("Files", element);
    });
    // formData.append("Files", filesUploader.files);
    return new Promise<ResultUploader[]>((resolve, reject) => {
      this.axios
        .post<ResultUploader[]>(
          `${this.cdnUrl}api/upload/document/multiple`,
          formData,
          {
            headers: null
          }
        )
        .then(response => resolve(response.data as ResultUploader[]))
        .catch((error: any) => reject(error));
    });
  }

  UploadMultipleFiles(filesUploader: FilesUploader): Promise<ResultUploader[]> {
    const formData = new FormData();
    formData.append("Folder", filesUploader.folder || "");
    filesUploader.files.forEach(element => {
      formData.append("Files", element);
    });
    return new Promise<ResultUploader[]>((resolve, reject) => {
      this.axios
        .post<ResultUploader[]>(`${this.cdnUrl}api/upload/multiple`, formData, {
          headers: null
        })
        .then(response => resolve(response.data as ResultUploader[]))
        .catch((error: any) => reject(error));
    });
  }
}
